import { Box, Tabs } from "@mui/material";
import { TabPanel } from "components/tabPanel";
import { useState } from "react";
import Workers from "./workers";
import Finance from "./finance";
import Requisites from "./requisites";
import { StyledTab } from "utils/formatters";

// страница компании и её вкладки
export function Company() {
    const [tab, setTab] = useState(0);
    const handleChange = (event, newTab) => {
        setTab(newTab);
    };

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example" sx={{
                "& .MuiTabs-indicator": {
                    display: "none"
                },
                padding: '1% 0% 1% 1%',
                backgroundColor:'white',
                borderBottom: '2px solid #d9d9d9'
            }}>
                <StyledTab label="Сотрудники" />
                {/* <StyledTab label="Основные расходы" />
                <StyledTab label="Реквизиты" /> */}
            </Tabs>
            <TabPanel value={0} select={tab}>
                {<Workers></Workers>}
            </TabPanel>
            {/* <TabPanel value={1} select={tab}>
                {<Finance></Finance>}
            </TabPanel>
            <TabPanel value={2} select={tab}>
                {<Requisites></Requisites>}
            </TabPanel> */}

        </Box>
    );

}